import { render, staticRenderFns } from "./AppCarousel.vue?vue&type=template&id=97b6ca18"
import script from "./AppCarousel.vue?vue&type=script&lang=js"
export * from "./AppCarousel.vue?vue&type=script&lang=js"
import style0 from "swiper/swiper-bundle.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports